import { ThemeConfig } from "./themeTypes"; 

export const themeConfig: ThemeConfig = {
    primaryColor: "#222222",
    mainFontColor: "#333333",
    viceFontColor: "#666666",
    fontFamily: "avenir,sans-serif",
    navColor: "#F2F2F2",
}